module.exports = __webpack_public_path__ + "static/media/zoomMax.f2acac99.svg";